export function registerNativeAppStatusCallback() {
  window.nativeCallbackAppStatus = status => console.log('nativeCallbackAppStatus', status);
}
